module.exports = __webpack_public_path__ + "static/media/resource-icon.49a24a5b.svg";